import React,{useState, useEffect} from 'react'
import { useSpotContext } from '../context/SpotProvider';
import { toast } from 'react-toastify';
import { Button } from '../components/Button';
import useAxios from '../api/axios';
import { ACTIVITY_ID } from '../constants/activity';

const bgtablebody = "bg-blue-300 text-gray-700";

export const ComfirmOrder3 = () => {
  const { getJustOrdered } = useSpotContext();
  const [spots, setSpots] = useState([]);
  const [bankReference, setBankReference] = useState(null);
  const [downloadingInvoice, setDownloadingInvoice] = useState(false);  
  const api = useAxios();
  const ordered = getJustOrdered();

  const total = spots.reduce((tot, spot) =>
    tot + (spot.fixedPrice
      ? Number.parseInt(spot.fixedPrice, 10)
      : Number.parseInt(spot.prize, 10) + ((spot.electricityType === "230V" || spot.electricityType === "400V") ? 15 : 0)), 0);
  
  useEffect(() => {
    let storedOrder = null;

    try {
      storedOrder = JSON.parse(sessionStorage.getItem('justOrdered'));
    } catch(err) {
      storedOrder = null;
    }

    const resolvedOrder = ordered ?? storedOrder;
    const nextBankReference = Array.isArray(resolvedOrder) ? null : resolvedOrder?.bankReference ?? null;

    console.info('ComfirmOrder3 resolved order', {
      ordered,
      storedOrder,
      resolvedOrder,
      bankReference: nextBankReference,
    });


    if(Array.isArray(resolvedOrder)) {
      setSpots(resolvedOrder);
      setBankReference(null);
      return;
    }

    setSpots(resolvedOrder?.spots ?? []);
    setBankReference(resolvedOrder?.bankReference ?? null);
  },[ordered]);

  const getDownloadErrorMessage = async (err) => {
    const responseData = err?.response?.data;

    if(responseData instanceof Blob) {
      const responseText = await responseData.text();

      try {
        const parsed = JSON.parse(responseText);
        return parsed?.msg ?? parsed?.message ?? responseText;
      } catch(parseErr) {
        return responseText || err?.message || 'Tuntematon virhe';
      }
    }

    if(typeof responseData === 'string') {
      return responseData;
    }

    if(responseData && typeof responseData === 'object') {
      return responseData?.msg ?? responseData?.message ?? JSON.stringify(responseData);
    }

    return err?.message ?? 'Tuntematon virhe';
  }

  const downloadInvoice = async () => {
    if(!bankReference) {
      toast.error('Laskun tiedot puuttuvat. Tee varaus uudelleen tai ota yhteys ylläpitoon.');
      return;
    }

    try {
      setDownloadingInvoice(true);

      const response = await api.get('/downloadInvoice', {
        params: {
          activityID: ACTIVITY_ID,
          invoiceReference: bankReference,
        },
        responseType: 'blob',
        headers: {
          Accept: 'application/pdf, application/octet-stream, application/json, text/plain',
        },
      });

      const contentDisposition = response.headers?.['content-disposition'];
      const fileNameMatch = contentDisposition?.match(/filename\*?=(?:UTF-8''|\")?([^\";]+)/i);
      const fileName = fileNameMatch?.[1]
        ? decodeURIComponent(fileNameMatch[1].replace(/\"/g, ''))
        : `lasku-${bankReference}.pdf`;
      const blob = new Blob([response.data], { type: response.data?.type || 'application/pdf' });
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = downloadUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch(err) {
      const errorMessage = await getDownloadErrorMessage(err);

      console.error('downloadInvoice failed', err, errorMessage);      
      toast.error(`Laskun lataus epäonnistui: ${errorMessage}`);
    } finally {
      setDownloadingInvoice(false);
    }
  }

  return (
    <div>

      
      <h1 className="text-2xl text-blue-800 text-center mt-4">Kiitos varauksestasi!</h1>      
      
      <h1 className="text-sm text-white text-center mt-4">Valitsemasi paikat on nyt varattu sinulle.</h1>      

      <div className="flex mt-4 justify-center items-center">
        <div className="w-full sm:w-3/4 md:w-1/2 lg:w-3/7 mx-2 grid grid-cols-4 border border-gray-300 items-center text-center">
        
          <div className="bg-gray-200 p-1 font-bold border border-gray-400">Tuote</div>
          <div className="bg-gray-200 p-1 font-bold border border-gray-400">Paikka</div>
          <div className="bg-gray-200 p-1 font-bold border border-gray-400">Tyyppi</div>
          <div className="bg-gray-200 p-1 font-bold border border-gray-400">Hinta</div>      

          {spots.map((spot,index) => (                            
              <React.Fragment key={`${spot.spotID ?? spot.name}-${index}`}>
                <div className={`p-1 ${bgtablebody} border border-gray-400`}>Paikkamaksu</div>
                <div className={`p-1 ${bgtablebody} border border-gray-400`}>{spot.name}</div>
                <div className={`p-1 ${bgtablebody} border border-gray-400`}>{spot.size}</div>
                <div className={`p-1 ${bgtablebody} border border-gray-400`}>{spot.fixedPrice ?? spot.prize} €</div>
                                
                {spot.electricityType !== "Ei sähköä" && (
                  <>
                    <div className={`p-1 ${bgtablebody} border border-gray-400`}>Sähkömaksu</div>
                    <div className={`p-1 ${bgtablebody} border border-gray-400`}>{spot.name}</div>
                    <div className={`p-1 ${bgtablebody} border border-gray-400`}>{spot.electricityType}</div>
                    <div className={`p-1 ${bgtablebody} border border-gray-400`}>{spot.fixedPrice ? 0 : 15} €</div>
                  </>
                )}    
              </React.Fragment>         
          ))}  

            <div className="col-span-3 bg-blue-500 p-1 font-bold border border-gray-400 text-right pr-4">Yhteensä</div>
            <div className={`p-1 bg-blue-500 border font-bold border-gray-400`}>{total} €</div>
        </div>
        
      </div>
      <h1 className="text-sm text-white text-center mt-4">Lähetämme laskun sähköpostilla laskutusosoitteeseesi.</h1>
      <div className="mt-4 flex justify-center">
        <Button
          name={downloadingInvoice ? "Ladataan laskua..." : "Lataa lasku"}
          type={downloadingInvoice ? "DISABLED" : "PRIMARY"}
          action={downloadingInvoice ? undefined : downloadInvoice}
        />
      </div>      
      <h1 className="text-sm text-white text-center mt-4">Muista maksaa lasku eräpäivään mennessä pitääksesi varauksesi voimassa</h1>
      <h1 className="text-md text-white text-center mt-4">Kiitos ja nähdään markkinoilla elokuussa.</h1>
    </div>
  )
}
